// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.06.2017 14:23:49
import { EtdResult_abstract } from './../../abstract/SagaBase/Defines/EtdResult_abstract';
export class EtdResult extends EtdResult_abstract {}
